export default __webpack_public_path__ + "static/media/LOGO BLANC-300.9319df38.png";